module.exports = __webpack_public_path__ + "img/icon-arrow-up.af87187d.svg";